<app-alerts></app-alerts>


<div  *ngIf="!loading; else load" class="row">
	<div class="col-12">
 
           <nb-card>
           <nb-card-header style="border-bottom:0 !important;">
                Продаж - {{stat?.title || ''}}
           </nb-card-header>
           	<nb-card-body style="
    margin: 0px !important;
    padding: 0px !important;
">
     

			 
 			 <table class="table  table-hover" *ngIf="stat?.items?.length">

		<thead >
		<tr><td>Дата</td><td>Email</td><td>Тип</td> <td>Код</td> <td>Сума</td>  <td>ID</td>  </tr>
		</thead>
		<tbody >
		<tr *ngFor="let item of stat.items">
			<td>{{item.created_at   | dateFormattedPipe : 'noSeconds'  }}</td>
			<td>{{item.email || '-'}}</td>
			 <td>{{item.type === 1? 'Купівля' : 'Донат'}}</td>
			<td>{{item.code || '-'}}</td>
			 <td>{{item.amount | number:'1.2'}} грн.</td>
			 <td>{{item.orderId}}</td>
		</tr>

		</tbody>
		</table>
		  
        	</nb-card-body>
           </nb-card> 
      
	</div>

</div>


<ng-template #load>
      <app-skeleton-page [height]="'900px'" [type]="'table'" ></app-skeleton-page>

   
</ng-template> 

